import Expander from '@amzn/meridian/expander';
import React, { useState } from 'react';
export const ControlledExpander = (props: any) => {
  const [open, setOpen] = useState(false);
  return <Expander open={open} onChange={setOpen} {...props} />;
};
